import { render, staticRenderFns } from "./UrlCadastro.vue?vue&type=template&id=ea4ede80&scoped=true&"
import script from "./UrlCadastro.vue?vue&type=script&lang=js&"
export * from "./UrlCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4ede80",
  null
  
)

export default component.exports